import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="kpis" routeLang="es" />;

export const Route = createFileRoute("/herramientas/kpis")({
  head: () => publicToolHead("kpis", "es"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});